import React from 'react'
import { AccessType } from 'app/auth/accessControlService'
import { Routes } from 'app/services/routeService/routeService'
import appConfigs from 'app/configs/appConfigs'
import BadgeBillingOverviewNotification from 'app/components/BadgeBillingOverviewNotification'
import AddCommentOutlinedIcon from '@material-ui/icons/AddCommentOutlined'
import DvrOutlinedIcon from '@material-ui/icons/DvrOutlined'
import FolderSharedOutlinedIcon from '@material-ui/icons/FolderSharedOutlined'
import SettingsRemoteOutlinedIcon from '@material-ui/icons/SettingsRemoteOutlined'
import PaymentOutlinedIcon from '@material-ui/icons/PaymentOutlined'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'
import {
  MessageIcon,
  HomeWorkIcon,
  DirectoryIcon,
  BeaconIcon,
  IntegrationIcon,
  BillingIcon,
  FixIcon,
  MessageTimelineIcon,
  ConversationIcon,
  TopicsIcon,
  GiftIcon,
  FilePersonIcon,
  SubscriberIcon,
  SettingIcon,
  WidgetIcon,
  LinkIcon,
  MemberCardIcon,
  UsageSummaryIcon,
  UsageHistoryIcon,
  DeviceHubIcon,
  KeyIcon,
  InitailIcon,
  ComposeIcon,
  AiUsageLog,
} from 'app/components/icons'
import StarOutlinedIcon from '@material-ui/icons/StarOutlined'

const navigationConfig = [
  {
    id: 'create-a-notification',
    title: 'Create a notification',
    type: 'send-message-button',
    componentIcon: <AddCommentOutlinedIcon className="text-white" />,
    localizedId: 'navigation.notifications.create.label',
    accesses: [AccessType.NOTIFICATION_SEND, AccessType.ADMINISTRATION],
    isSelected: false,
    children: [],
  },
  {
    title: 'Profile',
    id: 'profile',
    type: 'profile',
    componentIcon: <DvrOutlinedIcon />,
    isSelected: false,
    localizedId: 'navigation.profile.profile.label',
    children: [
      {
        title: 'Profile Info',
        id: 'profile',
        type: 'item',
        parentId: 'profile',
        componentIcon: <HomeWorkIcon color="#183560" classes="w-24 mx-3" />,
        url: Routes.profileInfo(),
        isDefault: true,
        isSelected: false,
        localizedId: 'navigation.profile.profileInfo.label',
        accesses: [
          AccessType.ADMINISTRATION,
          AccessType.PLACE_PENDING_ACTIVATE,
        ],
      },
    ],
  },
  {
    title: 'Profile Info',
    id: 'profile-info',
    type: 'profile-info',
    componentIcon: <HomeWorkIcon classes="w-22" />,
    isSelected: false,
    localizedId: 'navigation.profile.profile.label',
    children: [
      {
        title: 'Profile Info',
        id: 'profile-info',
        type: 'item',
        parentId: 'profile-info',
        componentIcon: <HomeWorkIcon color="#183560" classes="w-24 mx-3" />,
        url: Routes.profileInfoV4(),
        isDefault: true,
        isSelected: false,
        localizedId: 'navigation.profile.profileInfo.label',
        accesses: [
          AccessType.ADMINISTRATION,
          AccessType.PLACE_PENDING_ACTIVATE,
        ],
      },
    ],
  },
  {
    title: 'Notifications',
    id: 'notifications',
    type: 'collapse',
    isSelected: true,
    localizedId: 'navigation.notifications.label',
    componentIcon: <DvrOutlinedIcon className="text-grey-neutral" />,
    children: [
      {
        id: 'notification-timeline',
        title: 'Notification Timeline',
        type: 'item',
        componentIcon: <MessageTimelineIcon classes="mx-2 w-20" />,
        parentId: 'notifications',
        url: Routes.notificationTimeline(),
        isDefault: true,
        isSelected: false,
        localizedId: 'navigation.profile.notificationTimeline.label',
        accesses: [
          AccessType.NOTIFICATION_VIEW_OWNED,
          AccessType.ADMINISTRATION,
        ],
      },
      {
        id: 'timeline-favorites',
        title: 'Timeline favorites',
        type: 'item',
        componentIcon: (
          <StarOutlinedIcon fontSize="small" className="mx-2 w-20" />
        ),
        parentId: 'notifications',
        url: Routes.notificationFavolites(),
        isDefault: true,
        isSelected: false,
        localizedId: 'navigation.favorites',
        accesses: [
          AccessType.NOTIFICATION_VIEW_OWNED,
          AccessType.ADMINISTRATION,
        ],
      },
      {
        id: 'Conversation',
        title: 'Conversation List',
        type: 'item',
        parentId: 'notifications',
        componentIcon: <ConversationIcon classes="mx-2 w-20" />,
        url: Routes.conversation(),
        isDefault: false,
        isSelected: false,
        localizedId: 'navigation.chats.label',
        accesses: [AccessType.NOTIFICATION_VIEW_OWNED],
      },
      {
        id: 'topics',
        title: 'Topics',
        type: 'item',
        parentId: 'notifications',
        componentIcon: <TopicsIcon classes="mx-2 w-20" />,
        url: Routes.topics(),
        isDefault: false,
        isSelected: false,
        localizedId: 'navigation.notifications.topics.label',
        accesses: [AccessType.NOTIFICATION_SEND, AccessType.ADMINISTRATION],
        children: [
          {
            id: 'topics-detail',
            title: 'Topics Detail',
            type: 'subItem',
            customIcon: null,
            url: '/topics/:topicsId',
            localizedId: null,
            accesses: [AccessType.NOTIFICATION_VIEW_OWNED],
          },
        ],
      },
      {
        id: 'deals-promotions',
        title: 'Deal & Promotion',
        type: 'item',
        parentId: 'notifications',
        componentIcon: <GiftIcon classes="mx-2 w-16" />,
        url: Routes.dealsPromotions(),
        isDefault: false,
        isSelected: false,
        localizedId: 'navigation.dealsPromotions.manageBeacons.label',
        children: [
          {
            id: 'redemption',
            title: 'Voucher redemption',
            type: 'subItem',
            customIcon: null,
            url: '/deals-promotions/redemption',
            localizedId: null,
            accesses: [
              AccessType.ADMINISTRATION,
              AccessType.NOTIFICATION_VIEW_OWNED,
              AccessType.NOTIFICATION_VIEW_ALL,
              AccessType.SUBSCRIBER_VIEW,
            ],
          },
        ],
        accesses: [
          AccessType.NOTIFICATION_VIEW_OWNED,
          AccessType.ADMINISTRATION,
        ],
      },
    ],
  },
  {
    id: 'directory',
    title: 'Directory',
    type: 'collapse',
    isSelected: false,
    localizedId: 'navigation.directory.label',
    componentIcon: <FolderSharedOutlinedIcon className="text-grey-neutral" />,
    children: [
      {
        id: 'subscribersV4',
        title: 'SubscribersV4',
        type: 'item',
        url: Routes.subscribersV4(),
        componentIcon: <SubscriberIcon classes="mx-2 w-24" />,
        isDefault: true,
        isSelected: false,
        parentId: 'directory',
        localizedId: 'navigation.directory.subscribers.label',
        accesses: [AccessType.SUBSCRIBER_VIEW, AccessType.ADMINISTRATION],
        children: [
          {
            id: 'subscribers-crm-detail',
            title: 'Subscriber V4 detail',
            type: 'subItem',
            customIcon: null,
            url: Routes.subscribersV4Detail(),
            localizedId: null,
            accesses: [AccessType.SUBSCRIBER_VIEW, AccessType.ADMINISTRATION],
          },
          {
            id: 'import-subscriber',
            title: 'Import subscriber',
            type: 'subItem',
            customIcon: null,
            url: Routes.importSubscriberV4(),
            localizedId: null,
            accesses: [AccessType.SUBSCRIBER_VIEW, AccessType.ADMINISTRATION],
          },
        ],
      },
      {
        id: 'subscribers',
        title: 'Subscribers',
        type: 'item',
        parentId: 'directory',
        url: Routes.subscribersV4(),
        componentIcon: <SubscriberIcon classes="mx-2 w-24" />,
        isDefault: true,
        isSelected: false,
        localizedId: 'navigation.directory.subscribers.label',
        accesses: [AccessType.SUBSCRIBER_VIEW, AccessType.ADMINISTRATION],
        children: [
          {
            id: 'subscriber-detail',
            title: 'Subscriber detail',
            type: 'subItem',
            customIcon: null,
            url: '/subscribers/:subscriberId',
            localizedId: null,
            accesses: [AccessType.SUBSCRIBER_VIEW, AccessType.ADMINISTRATION],
          },
          {
            id: 'import-subscriber',
            title: 'Import subscriber',
            type: 'subItem',
            customIcon: null,
            url: Routes.importSubscriberV4(),
            localizedId: null,
            accesses: [AccessType.SUBSCRIBER_VIEW, AccessType.ADMINISTRATION],
          },
        ],
      },
      {
        id: 'groups',
        title: 'Groups',
        type: 'item',
        parentId: 'directory',
        url: Routes.groups(),
        isDefault: false,
        isSelected: false,
        componentIcon: <FilePersonIcon classes="mx-2 w-24" />,
        localizedId: 'navigation.directory.groups.label',
        accesses: [
          AccessType.NOTIFICATION_VIEW_OWNED,
          AccessType.ADMINISTRATION,
        ],
        children: [
          {
            id: 'groups-detail',
            title: 'Groups Detail',
            type: 'subItem',
            customIcon: null,
            url: Routes.groupsDetail(),
            // url: Routes.groupsDetailV4(),
            localizedId: null,
            accesses: [
              AccessType.NOTIFICATION_VIEW_OWNED,
              AccessType.ADMINISTRATION,
            ],
          },
        ],
      },
    ].filter((m) => m !== undefined),
  },
  {
    id: 'Conversation',
    title: 'Conversation List',
    type: 'chat-manager-web',
    componentIcon: <ConversationIcon classes="mx-2 w-20" />,
    localizedId: 'navigation.chats.label',
    accesses: [AccessType.NOTIFICATION_VIEW_OWNED],
    isSelected: false,
    children: [],
  },
  {
    id: 'beacons',
    title: 'Beacons',
    type: 'collapse',
    isSelected: false,
    componentIcon: <SettingsRemoteOutlinedIcon className="text-grey-neutral" />,
    localizedId: 'navigation.beacons.label',
    children: [
      {
        id: 'beacon-notifications',
        title: 'Beacon Notifications',
        type: 'item',
        parentId: 'beacons',
        url: Routes.beaconNotification(),
        componentIcon: <BeaconIcon color="#183560" classes="mx-2 w-24" />,
        isDefault: true,
        isSelected: false,
        localizedId: 'navigation.beacons.beaconNotifications.label',
        accesses: [AccessType.ADMINISTRATION],
      },
      {
        id: 'manage-beacons',
        title: 'Manage Beacons',
        type: 'item',
        parentId: 'beacons',
        url: Routes.manageBeacon(),
        componentIcon: <SettingIcon classes="mx-2 w-24" />,
        isDefault: false,
        isSelected: false,
        localizedId: 'navigation.beacons.manageBeacons.label',
        accesses: [AccessType.ADMINISTRATION],
      },
    ],
  },
  {
    title: 'Integrations',
    id: 'integrations',
    type: 'collapse',
    isSelected: false,
    localizedId: 'navigation.integrations.label',
    componentIcon: <IntegrationIcon classes="w-24" />,
    children: [
      {
        id: 'subscriber-widget',
        title: 'Subscriber Widget SDK',
        type: 'item',
        parentId: 'integrations',
        componentIcon: <WidgetIcon classes="mx-2 w-21" />,
        url: Routes.subscriberWidget(),
        isDefault: true,
        isSelected: false,
        localizedId: 'navigation.integrations.subscriberWidget.label',
        accesses: [AccessType.ADMINISTRATION],
      },
      {
        id: 'social-media-integrations',
        title: 'Link Social Media Accounts',
        type: 'item',
        parentId: 'integrations',
        url: Routes.socialMediaIntegrations(),
        componentIcon: <LinkIcon classes="mx-2 w-21" />,
        isDefault: false,
        isSelected: false,
        localizedId: 'navigation.settings.socialMediaIntegrations.v2.label',
        accesses: [AccessType.ADMINISTRATION],
      },
    ],
  },
  {
    id: 'plans-and-billing',
    title: 'plans-and-billing',
    type: 'collapse',
    isSelected: false,
    localizedId: 'navigation.settings.planAndBilling.label',
    headerId: 'planAndBilling.billingOverview.header',
    componentIcon: <PaymentOutlinedIcon className="text-grey-neutral" />,
    children: [
      {
        id: 'billing-overview',
        title: 'Plan & Billing',
        type: 'item',
        parentId: 'plans-and-billing',
        componentIcon: <MemberCardIcon classes="mx-2 w-20" />,
        url: Routes.billingOverview(),
        isDefault: true,
        isSelected: false,
        localizedId: 'navigation.planAndBilling.billingOverview.label',
        accesses: [AccessType.ADMINISTRATION],
        badge: {
          title: <BadgeBillingOverviewNotification />,
          bg: 'transparent',
          fg: '#D9222A',
        },
      },
      {
        id: 'usage-summary',
        title: 'Usage Summary',
        type: 'item',
        parentId: 'plans-and-billing',
        componentIcon: <UsageSummaryIcon classes="mx-2 w-16" />,
        url: Routes.usageSummary(),
        isDefault: false,
        isSelected: false,
        localizedId: 'navigation.planAndBilling.usageSummary.label',
        accesses: [AccessType.ADMINISTRATION],
      },
      {
        id: 'usage-history',
        title: 'Usage History',
        type: 'item',
        parentId: 'plans-and-billing',
        componentIcon: <UsageHistoryIcon classes="mx-2 w-21" />,
        url: Routes.usageHistory(),
        isDefault: false,
        isSelected: false,
        localizedId: 'navigation.planAndBilling.usageHistory.label',
        accesses: [AccessType.ADMINISTRATION],
      },
      {
        id: 'ai-usage-log',
        title: 'AI Usage Log',
        type: 'item',
        parentId: 'plans-and-billing',
        componentIcon: <AiUsageLog classes="mx-2 w-21" />,
        url: Routes.aiUsageLog(),
        isDefault: false,
        isSelected: false,
        localizedId: 'navigation.planAndBilling.aiUsageLog.label',
        accesses: [AccessType.ADMINISTRATION],
      },
    ],
  },
  {
    id: 'settings',
    title: 'Settings',
    type: 'collapse',
    isSelected: false,
    componentIcon: <SettingsOutlinedIcon className="text-grey-neutral" />,
    localizedId: 'navigation.settings.label',
    children: [
      {
        id: 'manage-channels',
        title: 'Manage Channels',
        type: 'item',
        parentId: 'settings',
        url: Routes.manageChannels(),
        isDefault: true,
        isSelected: false,
        componentIcon: <DeviceHubIcon classes="mx-2 w-21" />,
        localizedId: 'navigation.settings.manageChannels.label',
        accesses: [AccessType.ADMINISTRATION],
      },
      {
        id: 'team-members',
        title: 'Team Members',
        type: 'item',
        parentId: 'settings',
        url: Routes.teamMembers(),
        isDefault: false,
        isSelected: false,
        componentIcon: <WidgetIcon classes="mx-2 w-21" />,
        localizedId: 'navigation.settings.teamMembers.label',
        accesses: [AccessType.ADMINISTRATION],
      },
      {
        id: 'roles-permissions',
        title: 'Roles & Permissions',
        type: 'item',
        parentId: 'settings',
        componentIcon: <KeyIcon classes="mx-2 w-21" />,
        url: '/settings/roles-permissions',
        isDefault: false,
        isSelected: false,
        localizedId: 'navigation.settings.rolesPermissions.label',
        accesses: [AccessType.ADMINISTRATION],
      },
      {
        id: 'initial-notification',
        title: 'Initial Notification',
        type: 'item',
        parentId: 'settings',
        url: Routes.initialNotification(),
        isDefault: false,
        isSelected: false,
        componentIcon: <InitailIcon classes="mx-2 w-20" />,
        localizedId: 'navigation.settings.initialNotification.label',
        accesses: [
          AccessType.NOTIFICATION_SEND,
          AccessType.NOTIFICATION_UNSENT_OWNED,
          AccessType.ADMINISTRATION,
        ],
      },
    ].filter(
      (menu) =>
        appConfigs.isSocialPostingEnabled ||
        menu.id !== 'social-media-integrations',
    ),
  },
]
export default navigationConfig
